module.exports = __webpack_public_path__ + "img/link_bg.a98f968.png";